import './ui/tokens.css';
import './ui/app.css';
import { store, AppState } from './store/gameStore';
import { renderLobby } from './ui/lobby';
import { renderTutorial } from './ui/tutorial';
import { renderLesson } from './ui/lessonView';
import { renderTable } from './ui/table';
import { startMusic } from './ui/sound';

const app = document.getElementById('app')!;

// 브라우저 자동재생 정책상 BGM은 첫 사용자 제스처에 시작(설정 켜짐일 때만)
window.addEventListener('pointerdown', () => startMusic(), { once: true });

function render(state: AppState): void {
  let view: HTMLElement;
  // 인터랙티브 레슨이 열려 있으면 우선 렌더
  if (state.activeLesson) {
    view = renderLesson(state);
    app.replaceChildren(view);
    return;
  }
  switch (state.screen) {
    case 'tutorial':
      view = renderTutorial(state);
      break;
    case 'game':
      view = state.game ? renderTable(state) : renderLobby(state);
      break;
    case 'lobby':
    default:
      view = renderLobby(state);
  }
  app.replaceChildren(view);
}

render(store.getState());
store.subscribe(render);
